// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"330":"d53c668a","572":"87df0847"}[chunkId] + ".chunk.js";
};